<template>
  <el-dialog
    title="添加商品"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
    @open="opened"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-input
      placeholder="请输入件号或关键字搜索"
      v-model="keyword"
      class="input-with-select"
      prefix-icon="el-icon-search"
      clearable
    ></el-input>
    <el-table
      v-if="items.length > 0"
      ref="multipleTable"
      @selection-change="handleItemSelectionChange"
      :data="items"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="part_number" label="件号" width="240">
        <template slot-scope="scope">
          <div>
            {{ scope.row.part_number
            }}<i class="font-12 font-normal"
              >（{{ scope.row.type == 1 ? '备件' : '服务' }}）</i
            >
            <el-tag
              size="mini"
              effect="dark"
              type="danger"
              v-if="scope.row.status == 0"
              >未上架</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="commodity_category.name"
        label="类型"
        width="160"
      ></el-table-column>
      <el-table-column prop="description" label="描述"></el-table-column>
      <el-table-column prop="price" label="单价" width="100">
        <template slot-scope="scope">{{
          scope.row.dealer_price.toFixed(2)
        }}</template>
      </el-table-column>
    </el-table>
    <div class="text-info-12 mt-10" v-else>
      {{ keyword.length > 0 ? '未找到对应商品' : '' }}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submit"
        >确认添加</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { commodityList, commodityOrderAddItem } from '@/service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderid: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    keyword: 'searchItems',
  },
  data() {
    return {
      keyword: '',
      visible: this.show,
      items: [],
      selectionTmp: [],
      submiting: false,
    }
  },
  methods: {
    async searchItems() {
      let items = []
      this.items = []
      if (this.keyword && this.keyword.length > 0) {
        let res = await commodityList({
          page: 0,
          size: 10,
          // status: 1,
          commodity_order_id: this.orderid,
          part_number: this.keyword,
        })

        if (res.code == 0) {
          items = res.data.list
        }
      }

      this.items = items
    },
    handleItemSelectionChange(val) {
      this.selectionTmp = val.map((item) => {
        return item.id
      })
    },
    async submit() {
      let res = await commodityOrderAddItem({
        commodity_order_id: this.orderid,
        commodity_ids: this.selectionTmp,
      })

      if (res.code == 0) {
        this.$notify({
          title: '操作提示',
          message: '添加成功！',
          type: 'success',
          duration: 2000,
        })

        this.visible = false
        this.$emit('selected', res.data)
      }
    },
    opened() {
      this.keyword = ''
      this.items = []
      this.selectionTmp = []
    },
  },
}
</script>